import { useContext } from 'react';
import { AuthContext } from './auth-context';

/**
 * Hook to access authentication context
 *
 * @returns AuthContextType with user, session, loading state, and auth methods
 * @throws Error if used outside of AuthProvider
 *
 * @example
 * ```tsx
 * function DashboardPage() {
 *   const { user, loading, signOut } = useAuth();
 *
 *   if (loading) {
 *     return <LoadingSpinner />;
 *   }
 *
 *   return (
 *     <div>
 *       <p>Welcome, {user?.email}</p>
 *       <button onClick={signOut}>Sign Out</button>
 *     </div>
 *   );
 * }
 * ```
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
